// Eyes-free feedback — R7.13c: accepted / rejected / attention distinguishable by
// sound and vibration without looking at the screen.

import { getPrefs } from "../api/client.js";
import { confirmScan } from "./native.js";

let ctx: AudioContext | null = null;

/** The device setting decides the level: a warehouse wants it loud, a desk does not. The
 *  phone's own silent switch still mutes web audio on iOS; the settings page says so. */
function gainFor(): number {
  const s = getPrefs().sound;
  return s === "off" ? 0 : s === "normal" ? 0.12 : 0.5;
}

function beep(freq: number, ms: number, when = 0): void {
  try {
    const gain = gainFor();
    if (gain === 0) return;
    ctx ??= new AudioContext();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "square";
    o.frequency.value = freq;
    g.gain.value = gain;
    o.connect(g).connect(ctx.destination);
    const t = ctx.currentTime + when;
    o.start(t);
    o.stop(t + ms / 1000);
  } catch {
    /* audio unavailable */
  }
}

export type FeedbackKind = "accepted" | "rejected" | "attention";

export function feedback(kind: FeedbackKind): void {
  // A dedicated scanner set to wait for the host's verdict beeps and lights from this.
  confirmScan(kind !== "rejected");
  switch (kind) {
    case "accepted":
      beep(1400, 70);
      navigator.vibrate?.(40);
      break;
    case "rejected":
      beep(220, 180);
      beep(220, 180, 0.22);
      navigator.vibrate?.([120, 60, 120]);
      break;
    case "attention":
      beep(880, 120);
      beep(1100, 120, 0.15);
      beep(880, 120, 0.3);
      navigator.vibrate?.([60, 40, 60, 40, 60]);
      break;
  }
}

/** iOS requires a user gesture before audio can play; call once from a tap. */
export function unlockAudio(): void {
  try {
    ctx ??= new AudioContext();
    void ctx.resume();
  } catch {
    /* ignore */
  }
}
